import { AmplitudeExtendableEvent } from '@wetransfer/transfer/modules/analytics/vendors/amplitude';

export const TRANSFER_PURCHASE_FUNNEL__PAYMENT_COMPLETE__EVENT: AmplitudeExtendableEvent =
  {
    action: 'Transfer Purchase Funnel',
    additionalProperties: {
      Step: 'Payment Complete',
    },
  };

export const TRANSFER_PURCHASE_FUNNEL__PAYMENT_PROCESSING__EVENT: AmplitudeExtendableEvent =
  {
    action: 'Transfer Purchase Funnel',
    additionalProperties: {
      Step: 'Payment Processing',
    },
  };

export const TRANSFER_PURCHASE_FUNNEL__PAYMENT_FAILED__EVENT: AmplitudeExtendableEvent =
  {
    action: 'Transfer Purchase Funnel',
    additionalProperties: {
      Step: 'Payment Failed',
    },
  };
